import React, { useEffect, useState } from "react";
import { createHash } from "crypto";

import "./styles.css";
import logo from "../../utils/images/zostelLogo.svg";

const getSHA1 = function () {
    return createHash("sha1")
        .update(
            JSON.stringify({
                timestamp: Date.now(),
                rand: Math.random() * 10000
            })
        )
        .digest("hex")
        .substr(0, 10);
};

const AuthModal = ({ setSessionId }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let mounted = true;
        setTimeout(() => {
            if (mounted) {
                setVisible(true);
            }
        }, 500);

        return () => {
            mounted = false;
        };
    }, []);

    const createNewSession = () => {
        const sessionId = getSHA1();
        localStorage.setItem("sessionId", sessionId);
        return sessionId;
    };

    return (
        <section id="auth-modal">
            <form
                id="auth-form"
                action="https://auth.zostel.com/sso/client/redirect/sign_in/"
                method="POST"
                className={visible ? "visible" : ""}
            >
                <h1>
                    Sign in to <strong>Zo Supply</strong>
                </h1>
                <input
                    type="text"
                    value="B4xlJrpP2dPnLVJC8mu2U2McsSmhZNGocjpgCTIL"
                    name="client_app_id"
                    onChange={() => { }}
                    hidden
                />
                <input
                    type="text"
                    value={createNewSession()}
                    onChange={() => { }}
                    name="client_session_id"
                    hidden
                />
                <input
                    type="text"
                    value={window.location.origin + "/auth/callback"}
                    name="callback_url"
                    onChange={() => { }}
                    hidden
                />
                <button type="submit">
                    <img src={logo} alt="" />
                    Login with Zostel
        </button>
            </form>
        </section>
    );
};

export default AuthModal;
